/**
*	@author Camilo
*	@since  07/12/2017
**/
export class ConceptoModel{

	constructor(
		public id:DefOtrconcepId,
		public cdescon:string,
		public cctacxc:string,
		public cctaiva:string,
		public cingveniva:string,
		public cfidudeb:string,
		public deftipoiva:DefTipoiva,
		public nporcentaje:number,
		public nporcentajeimpuestoconsumo:number,
		public ncuentaimpuestoconsumo:string,
		public ncobraimpuestoconsumo:any,
		public cctaprov:string,
		public bloquear:any
		){}
}

export class DefOtrconcepId{
	constructor(public ccodcon:string, public cnumcont:string, public ciddoc:string){}
}

export class DefTipoiva{
	constructor(public ntipoiva:string){}
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearConcepto/Concepto.model.ts